export default "__VITE_ASSET__CGO4JPj1__"